/**
 * Filter sentinels for handling-party filters. Like the user "Me" sentinel
 * (`SYSTEM_ACCOUNT_IDS.CURRENT_USER`), these are never real handling-party ids and are
 * never persisted to a row — the filter layer swaps them for concrete ids when building
 * the where clause, so a shared saved view ("Mine") resolves per-viewer.
 */
export const HANDLING_PARTY_FILTER_SENTINELS = {
    /** "Mine" — expands to the viewing user's `handlingPartyIds` at where-build time. */
    CURRENT_USER: -9997n,
} as const;
